import { postLogingress } from '~/utils/logingress/logingress';
import { v4 as uuidv4 } from 'uuid';
import {
  selectedUbiePersonStorage,
  sessionTrackingStorage,
  ubieAuthStorage,
} from '~/utils/storage/inquiryUbieAppStorage';

const getAuthAccountId = () => {
  const { authAccountId } = ubieAuthStorage.get() ?? {};
  return authAccountId ?? null;
};

const getUbiePersonId = () => {
  const { id } = selectedUbiePersonStorage.get() ?? {};
  return id ?? null;
};

const getSessionTrackingUid = () => {
  const uid = sessionTrackingStorage.get();
  if (uid == null) {
    const newUid = uuidv4();
    sessionTrackingStorage.set(newUid);
    return newUid;
  } else {
    return uid;
  }
};

const generateParams = () => {
  return {
    auth_account_id: getAuthAccountId(),
    ubie_person_id: getUbiePersonId(),
    session_tracking_uid: getSessionTrackingUid(),
  };
};

export const sendPageViewToLogingress = async () => {
  await postLogingress({
    ...generateParams(),
    log_type: 'page_view',
    browser_language: (window.navigator.languages && window.navigator.languages[0]) || window.navigator.language,
  });
};

export const sendEventToLogingress = async (eventType: string, eventParams: object = {}) => {
  const content = JSON.stringify(eventParams);
  await postLogingress({
    ...generateParams(),
    log_type: 'patient_front_smartphone_web',
    event_type: eventType,
    content,
  });
};
